import { Connection } from './connection.model';
import { FatigueLoadCaseSelection } from './fatigue-load-case-selection.model';
import { Floater } from './floater.model';
import { Floating } from './floating.model';
import { DisplacementFunction } from './functions/displacement-function.model';
import { FluidFunction } from './functions/fluid-function.model';
import { HarmonicFunction } from './functions/harmonic-function.model';
import { RotationalFunction } from './functions/rotational-function.model';
import { TemperatureFunction } from './functions/temperature-function.model';
import { TimeFunction } from './functions/time-function.model';
import { Global } from './global.model';
import { Line } from './line.model';
import { AnalysisCase } from './load/analysis/analysis-case.model';
import { Assembly } from './load/assembly.model';
import { CurrentGroup } from './load/current/current-group';
import { Node } from './load/node/node.model';
import { WaveGroup } from './load/wave/wave-group.model';
import { MatCable } from './materials/mat-cable.model';
import { MatConnector } from './materials/mat-connector.model';
import { MatFlexJoint } from './materials/mat-flex-joint.model';
import { MatFlexLine } from './materials/mat-flex-line.model';
import { MatRigidTube } from './materials/mat-rigid-tube.model';
import { MatStiffener } from './materials/mat-stiffener.model';
import { MatStressJoint } from './materials/mat-stress-joint.model';
import { ReferenceSystem } from './reference-system/reference-system.model';
import { Result } from './results/result.model';
import { SnCurve } from './results/sn-curve/sn-curve.model';
import { Soil } from './soil.model';
import { Stiffener } from './stiffener.model';
import { Strake } from './strake.model';

export class Simulation {
  id: number;
  title: string;
  global: Global[];
  soil: Soil[];
  floatingProductionUnit: string;
  internalDiameterInches: number;
  interlId: number;
  wellInterconnection: string;
  revision: string;
  projectPhase: string;
  timeFunction: TimeFunction[];
  displacementFunction: DisplacementFunction[];
  rotationalFunction: RotationalFunction[];
  temperatureFunction: TemperatureFunction[];
  timeFunctionHarmonic: HarmonicFunction[];
  matFlexLine: MatFlexLine[];
  matStiffener: MatStiffener[];
  matConnector: MatConnector[];
  matRigidTube: MatRigidTube[];
  matCable: MatCable[];
  matFlexJoint: MatFlexJoint[];
  floating: Floating[];
  connection: Connection[];
  node: Node[];
  line: Line[];
  floater: Floater[];
  strake: Strake[];
  stiffener: Stiffener[];
  matStressJoint: MatStressJoint[];
  fluidFunction?: FluidFunction[];
  currentGroups: CurrentGroup[];
  waveGroups: WaveGroup[];
  analysisCase: AnalysisCase[];
  snCurve: SnCurve[];
  assembly: Assembly[];
  lastUpdated: Date;
  riserFunction: string;
  supportNumber: number;
  projectControlId: number;
  riserLengthAboveBellMouth: number;
  complementaryObservation: number;
  results: Result[];
  referenceSystem: ReferenceSystem[];
  fatigueLoadCaseSelectionFlex: FatigueLoadCaseSelection[];
  fatigueLoadCaseSelectionSteel: FatigueLoadCaseSelection[];

  constructor() {}
}
